//prepare hours to compare time ranges at calendar setup

export const prepareTime = ( date, time ) => {
    let newDate = new Date(date);
    const splitedTime = time.split(":");
    const hours = splitedTime[0];
    const minutes = splitedTime[1];
    
    return newDate.setHours( hours, minutes, 0, 0);
}